<template>
  <div class="root">
    <div class="params-form">
      <span>运单号：</span>
      <el-input v-model="waybillNumber"></el-input>
      <el-button
        class="glo_btnItems glo_bgcMainColor"
        size="small"
        @click="getDetail"
        >查询</el-button
      >
    </div>
    <el-container>
      <el-aside width="50%" class="part">
        <el-form
          ref="form"
          :model="form"
          label-position="right"
          label-width="100px"
          class="head_formBox glo_formBox1"
        >
          <el-form-item label="运单号">
            <el-input disabled v-model="form.waybillNumber"></el-input>
          </el-form-item>
          <el-form-item label="开单网点">
            <el-select disabled v-model="form.receiveOrderDeptId" filterable>
              <el-option
                v-for="dept in businessDepts"
                :key="dept.deptId"
                :label="dept.deptName"
                :value="dept.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="终端网点">
            <el-select disabled v-model="form.endDeptId" filterable>
              <el-option
                v-for="dept in businessDepts"
                :key="dept.deptId"
                :label="dept.deptName"
                :value="dept.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="目的站">
            <el-input disabled v-model="form.destCity"></el-input>
          </el-form-item>
          <el-form-item label="开单件数">
            <el-input disabled v-model="form.packageCount"></el-input>
          </el-form-item>
          <el-form-item label="未入库件数">
            <el-input disabled v-model="form.outStorageCount"></el-input>
          </el-form-item>
          <el-form-item label="开单时间">
            <el-input disabled v-model="form.createTime"></el-input>
          </el-form-item>
          <el-form-item label="运单状态">
            <el-input disabled v-model="form.waybillStatusShow"></el-input>
          </el-form-item>
        </el-form>
      </el-aside>
      <el-main class="part">
        <el-form
          :model="form"
          label-position="right"
          label-width="100px"
          class="head_formBox glo_formBox1"
        >
          <el-form-item label="加入库存网点" prop="storageId">
            <el-select v-model="form.storageId" filterable>
              <el-option
                v-for="dept in businessDepts"
                :key="dept.deptId"
                :label="dept.deptName"
                :value="dept.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="加入库存类型" prop="stockType">
            <el-select v-model="form.stockType" filterable>
              <el-option
                label="到货库存"
                value="dao_huo:stock_type"
              ></el-option>
              <el-option label="发货库存" value="fa_huo:stock_type"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      waybillNumber: "",
      form: {
        
      },
      businessDepts: [],
      rules: {
        cargoareaName: [
          {
            required: true,
            message: "请输入名称",
            trigger: ["change", "blur"],
          },
        ],
        storageId: [
          {
            required: true,
            message: "请选择仓库",
            trigger: ["change", "blur"],
          },
        ],
      },
    };
  },
  created() {
    this.getBusinessDepts();
  },
  methods: {
    getDetail() {
      const { waybillNumber } = this
      if (!waybillNumber) {
        return;
      }
      this.$API
        .runList({
          number: "admin_stock_waybill_detail_v5",
          waybillNumber,
        })
        .then((res) => {
          this.form = {
            ...res[0],
          };
        })
        .catch((err) => {});
    },
    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
    },
    async validate() {
      const res = await this.$refs.form.validate();
      return res;
    },
    save() {
      return new Promise(async (resolve, reject) => {
        const valid = await this.validate();
        if (valid) {
          this.$API
            .intoStock({
              billTmsWaybillSplitId:this.form.splitId,
              totalCount:this.form.packageCount,
              inStorageCount:this.form.packageCount,
              deptId:this.form.storageId,
              storageAreaId:this.form.storageAreaId,
              stockType:this.form.stockType
            })
            .then((res) => {
              resolve();
              this.clear();
            })
            .catch((err) => {
              reject();
            });
        } else {
          reject();
        }
      });
    },
    reset() {
      this.form = {};
    },
  },
};
</script>

<style lang="less" scoped>
.root {
  height: 450px;
  overflow: hidden;
  display: flex;
  flex-flow: column;
  .params-form {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #cccccc;
    .el-input {
      width: 200px;
      margin-right: 10px;
    }
  }
  .el-aside {
    border-right: 1px solid #cccccc;
    .el-form {
      width: 100%;
      .el-form-item {
        margin-bottom: 3px !important;
        width: 100% !important;
        .el-select{
          width: 100%;
        }
      }
    }
  }
  .part {
    padding: 10px;
  }
}
</style>